import http from '@/services/api';

const RESOURCE_NAME = 'api/settings/ms-teams-configuration';

export default {
  get(orgId) {
    return http.get(`${RESOURCE_NAME}/${orgId}`);
  }
};
